import React from "react";

function Icon() {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.79399 13.4346C11.7908 12.676 14 10.0622 14 6.95432C14 3.25271 10.866 0.251953 7 0.251953C3.13401 0.251953 0 3.25271 0 6.95432C0 9.64534 1.65634 11.966 4.04614 13.0325L3.98034 15.6384C3.97327 15.9183 4.29328 16.0942 4.54215 15.9471L8.79399 13.4346ZM11.0521 8.71801C11.0521 8.99595 10.9853 9.27118 10.8557 9.52797C10.7261 9.78476 10.5362 10.0181 10.2967 10.2146C10.0572 10.4112 9.77292 10.5671 9.46002 10.6734C9.14713 10.7798 8.81178 10.8345 8.4731 10.8345C8.13443 10.8345 7.79908 10.7798 7.48618 10.6734C7.17329 10.5671 6.88899 10.4112 6.64951 10.2146C6.41004 10.0181 6.22007 9.78476 6.09047 9.52797C5.96086 9.27118 5.89416 8.99595 5.89416 8.71801L8.4731 8.71801H11.0521Z"
        fill="url(#paint0_linear_13019_218)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_13019_218"
          x1="1.31016"
          y1="1.14002"
          x2="16.9621"
          y2="8.80657"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2603E" />
          <stop offset="1" stopColor="#F38B2B" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default Icon;
